import { useQuery } from "@tanstack/react-query";
import { LlmModelService } from "@/services/integrations/elevenlabs/LlmModelService";

const llmModelService = LlmModelService.getInstance();

export const llmModelKeys = {
  all: ["llm-models"] as const,
};

export const useLlmModels = (options?: { enabled?: boolean; forceRefresh?: boolean }) => {
  const { enabled = true, forceRefresh = false } = options || {};

  return useQuery({
    queryKey: [...llmModelKeys.all, forceRefresh ? "force" : "default"],
    queryFn: () => llmModelService.getModels(forceRefresh),
    staleTime: 60 * 1000,
    gcTime: 15 * 60 * 1000,
    retry: 2,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    enabled,
  });
};
